import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    open: false,
    key:'',
    top: 0,
    left: 0,
    placeholder: '',
    defaultvalue:'',
    onApply:null
};

const popuptextSlice = createSlice({
    name: 'popuptext',
    initialState,
    reducers: {
        popupopen: (state, action) => {
            return Object.assign({}, state, {
                open: true,
                key: action.payload.key,
                top: action.payload.top,
                left: action.payload.left,
                placeholder: action.payload.placeholder,
                defaultvalue: action.payload.defaultvalue === undefined? '':action.payload.defaultvalue,
                onApply: action.payload.onApply
            })
        },
        popupclose: (state, action) => {
            return initialState
        }
    },
});

export const {
    popupopen, popupclose
} = popuptextSlice.actions

export default popuptextSlice;

